var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls055(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 23.1941,
    width: 89.6149,
    height: 89.6149,
    rx: 10,
    transform: "rotate(-15 0 23.1941)",
    fill: "#F36EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5632 60.7666C58.3056 61.0111 57.4898 62.2503 57.7326 63.4998C57.9697 64.7196 59.1662 65.5986 60.4538 65.3483C61.7414 65.098 62.5514 63.8291 62.3143 62.6092C62.0714 61.3597 60.821 60.5221 59.5632 60.7666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7937 45.139C53.173 45.8428 51.9261 48.3053 52.2068 49.7493C52.4095 50.7923 53.3881 51.1016 54.1122 50.9608C55.5604 50.6793 54.5702 48.7349 57.3058 48.2032C58.6468 47.9425 59.834 48.3223 60.0731 49.5524C60.3538 50.9965 59.013 52.1174 58.2735 53.0382C57.6257 53.8579 56.8196 55.1524 57.2667 57.4521C57.537 58.8426 57.9903 59.1708 59.09 58.9571C60.4041 58.7016 60.5579 58.0612 60.4592 57.5531C60.1889 56.1626 60.0599 55.3551 61.3114 53.9185C61.9264 53.2162 63.8526 50.9547 63.364 48.441C62.8754 45.9273 60.2266 44.4717 56.7937 45.139Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6298 58.1792C36.4638 47.0362 43.7291 36.2669 54.8706 34.1012C66.0136 31.9352 76.7829 39.2005 78.9486 50.342C81.1146 61.485 73.8493 72.2543 62.7078 74.42L44.1233 78.0325C43.2535 78.2016 42.4113 77.6335 42.2422 76.7637L38.6298 58.1792ZM45.0863 74.5763L62.0958 71.27C71.4977 69.4424 77.6263 60.3548 75.799 50.9541C73.9714 41.5522 64.8838 35.4236 55.4832 37.2509C46.0812 39.0785 39.9526 48.1661 41.78 57.5668L45.0863 74.5763Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls055);
export default __webpack_public_path__ + "static/media/ils_05_5.07270752c3c06514bc9b826c222fd12b.svg";
export { ForwardRef as ReactComponent };